import { useEffect } from "react";
import {
  isReplyDraftStorageKey,
  purgeAllReplyDrafts,
} from "@/features/post/stores/replyDraftStore";
import {
  isThreadCreateDraftStorageKey,
  purgeAllThreadCreateDrafts,
} from "@/features/thread/stores/threadCreateDraftStore";

/** 旧クライアントが別タブから書き戻した本文を画面に依存せず破棄する。 */
export const LegacyDraftStorageCleanup: React.FunctionComponent = () => {
  useEffect(() => {
    const clearIncomingLegacyDraft = (event: StorageEvent): void => {
      if (event.newValue === null) return;
      if (isReplyDraftStorageKey(event.key)) purgeAllReplyDrafts();
      if (isThreadCreateDraftStorageKey(event.key)) {
        purgeAllThreadCreateDrafts();
      }
    };
    window.addEventListener("storage", clearIncomingLegacyDraft);
    return (): void => {
      window.removeEventListener("storage", clearIncomingLegacyDraft);
    };
  }, []);

  return null;
};
